import {apiConstants, AUTH_ERROR} from "./actions/constants";

export class AuthApiState {
  token: string = null;
  isLoading: boolean = false;
  error: string = null;
}

const authReducer = (state, action) => {
  if (state === undefined) {
    const key = localStorage.getItem("user_key");
    if (key) {
      return {
        ...state,
        token: key,
        isLoading: false
      };
    } else {
      state = new AuthApiState();
    }
  }

  switch (action.type) {
    case apiConstants.login.pending:
      return {
        ...state,
        isLoading: true
      };
    case apiConstants.login.fulfilled:
      localStorage.setItem("user_key", action.payload.key);
      console.log(action.payload.key)
      return {
        ...state,
        token: action.payload.key,
        isLoading: false,
        error: null
      };
    case apiConstants.login.rejected:
      return {
        ...state,
        isLoggedIn: false,
        error: action.payload.message
      };
    case apiConstants.logout.pending:
      return {
        ...state
      };
    case apiConstants.logout.fulfilled:
      localStorage.removeItem("user_key");
      return new AuthApiState();
    case apiConstants.logout.rejected:
      return {
        ...state
      };
    case AUTH_ERROR:
      localStorage.removeItem("user_key");
      return new AuthApiState();
    default:
      return state;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/redux/user.js